import { render } from "./FieldVitalityCheckCornIcon.vue?vue&type=template&id=477cff60"
import script from "./FieldVitalityCheckCornIcon.vue?vue&type=script&lang=js"
export * from "./FieldVitalityCheckCornIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__